/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input } from '@angular/core';
import { SimpleChartData } from '@app/app/shared/components/carts/SimpleChartData';

@Component({
  selector: 'ptl-simple-horizontal-bar-chart',
  templateUrl: './simple-horizontal-bar-chart.component.html',
  styleUrls: ['./simple-horizontal-bar-chart.component.scss'],
})
export class SimpleHorizontalBarChartComponent {
  @Input() chartData: SimpleChartData[];

  /** `v3` draws the chart in the v3 report's palette. Everywhere else it stays as it was. */
  @Input() variant: 'legacy' | 'v3' = 'legacy';
}
